import { render, staticRenderFns } from "./InternetLostPopUp.vue?vue&type=template&id=7b0854c4&scoped=true&"
import script from "./InternetLostPopUp.vue?vue&type=script&lang=js&"
export * from "./InternetLostPopUp.vue?vue&type=script&lang=js&"
import style0 from "./InternetLostPopUp.vue?vue&type=style&index=0&id=7b0854c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0854c4",
  null
  
)

export default component.exports